.f6{width:max-content;}